import type { ReactNode } from 'react';
import { Logomark } from '../../atoms/Logomark/Logomark';
import styles from './SidebarHeader.module.css';

/**
 * Figma: `Sidebar Header` (48:2881) — 44px tall, `space/16` horizontal padding,
 * with a 1px bottom border.
 *
 * The 2026-08-13 update made the row `SPACE_BETWEEN`, with the brand mark left
 * and a `NotificationButton` right. The 2026-09 update took the button back out:
 * the header holds one child again, the `Logomark`, and its layout is back to
 * MIN. `actions` stays because `NotificationButton` is still its own component
 * and the slot costs nothing empty — `space-between` with one child puts it
 * left, which is exactly what MIN does.
 *
 * The default brand is the lone 24px `Logomark_Old` instance (50:3020) that
 * Figma's Sidebar draws, with no wordmark beside it.
 */
export type SidebarHeaderProps = {
  /** Defaults to the logomark; override to slot in a different brand. */
  children?: ReactNode;
  /**
   * The right-hand slot. Figma drew a `NotificationButton` here between the
   * 2026-08-13 and 2026-09 updates and draws nothing there now; omitted, the
   * brand sits alone.
   */
  actions?: ReactNode;
  className?: string;
};

export function SidebarHeader({ children, actions, className }: SidebarHeaderProps) {
  return (
    <header className={className ? `${styles.header} ${className}` : styles.header}>
      {/* With no wordmark beside it, the mark itself carries the "DeepDive" name. */}
      {children ?? <Logomark />}
      {actions}
    </header>
  );
}
